export const WORKFLOW_SLICE_NAME = "workflow"
